import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-normal-modal',
  templateUrl: './normal-modal.component.html',
})
export class NormalModalComponent implements OnInit {

  public loadingConfirmation: boolean;

  constructor(
    public dialogRef: MatDialogRef<NormalModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
  ) {
  }

  closeClick(): void {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

  redirect() {
    if (this.data.redirectUrl && this.data.queryParams) {
      this.router.navigate([this.data.redirectUrl], {
        queryParams: this.data.queryParams
      });
    }
    this.dialogRef.close(true);
  }
}
